import { connect } from 'react-redux'

import './Login.scss'

function LoginLeft(props) {
  return (
    <div className="loginLeft">
      <div className="loginLeftControl">
        <div className="appLogo">
          {/* <LogoLarge /> */}
          <video
            src={require('../../assets/logo/logo_video.mp4')}
            autoPlay
            loop
            muted
            playsInline
            className="logoVideo"
          />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginLeft)
